import React, { useState } from "react"
import { DatoCmsSlugsConfiguration, DatoCmsThematicFolder, ThematicFolderPageQuery } from "../../../graphql-types"
import * as stylesNewsletter from "../../components/newsletter/newsletter.module.scss"
import Layout from "../../components/layout/layout"
import Banner from "./banner/banner"
import { graphql, Script } from "gatsby"
import useSlugValue from "../../hooks/use-slug-value"
import { useQueryParam } from "use-query-params"
import { StringParam } from "use-query-params"
import Cover from "./cover/cover"
import ThematicFolders from "./thematic-folders/thematic-folders"
import SEO from "../../components/seo"
import HrefLangLinks from "../../components/layout/href-lang-links/href-lang-links"
import Ariane from "../../components/layout/ariane/ariane"

type ThematicFolderPageProps = {
  data: ThematicFolderPageQuery
  pageContext: {
    locale: string
    defaultLocale: string
    slugs: DatoCmsSlugsConfiguration
  }
}

const ThematicFolderPage: React.FC<ThematicFolderPageProps> = ({ data, pageContext }) => {

  const projectsNewsInsightsPageSlug = useSlugValue(
    pageContext.slugs._allProjectsNewsInsightsPageSlugLocales,
    pageContext.locale
  )

  const breadcrumb = [
    {
      link: "/",
      title: pageContext.locale === pageContext.defaultLocale ? "Accueil" : "Home",
    },
    {
      link: data.datoCmsSlugsConfiguration.thematicFoldersPageSlug,
      title: data.datoCmsThematicFoldersPage.title,
    },
  ]

  const filterThematicFolders = (filteredThematicFolder: []) => {
    setThematicFolders(filteredThematicFolder)
  }

    const [searchTerms, _] = useQueryParam("query", StringParam)
    const siteSearchUrl = "https://unpkg.com/datocms-search@0.1.8/dist/datocms-search.base.js"
    const [siteSearchLoaded, setSiteSearchLoaded] = useState(typeof window !== "undefined" && !!window["DatoCmsSearch"])
    const thematicFolderSlug = useSlugValue(pageContext.slugs._allThematicFoldersPageSlugLocales, pageContext.locale)
    const [thematicFolders, setThematicFolders] = useState(data.datoCmsThematicFoldersPage.thematicFolders)

    return (
        <Layout
        pageContext={pageContext}
        currentRoute={thematicFolderSlug}
        headerConfig={data.datoCmsHeader}
        footerConfig={data.datoCmsFooter}
        noIndex={!!searchTerms}
      >
        <Script src={siteSearchUrl} onLoad={() => setSiteSearchLoaded(true)} />
        <div>
          <Banner
            data={data.datoCmsThematicFoldersPage}
          />
          <Ariane breadcrumb={breadcrumb.map(page => ({ ...page, slug: page.link }))} pageContext={pageContext}/> 
          <Cover
            data={data.datoCmsThematicFoldersPage}
            filters={data.datoCmsThematicFoldersPage.thematicFolders.map((thematicFolder) => thematicFolder.tfThumbnailTitle ?? thematicFolder.thematicTitle) || []}
            filterThematicFolders={filterThematicFolders}
            thematicFolders={data.datoCmsThematicFoldersPage.thematicFolders as unknown as DatoCmsThematicFolder[]}
          />
          <ThematicFolders
              thematicFolders={thematicFolders as unknown as DatoCmsThematicFolder[]}
              data={data.datoCmsThematicFoldersPage}
              thematicFoldersPageSlug={data.datoCmsSlugsConfiguration.thematicFoldersPageSlug}
              projectsNewsInsightsPageSlug={projectsNewsInsightsPageSlug}
          />
        </div>
        <section className={stylesNewsletter.container}>
        <div className={stylesNewsletter.iframe}>
          {pageContext.locale === pageContext.defaultLocale ? (
            <iframe
              title="Landing Page"
              src="https://f.inno.keolis.com/f/l/?q=BSLqpzmY16RtCSEShgohLdWayZ7VLugElOIBd2us19BPYmcYHtWnKpZ_ghOHlwepKS8vEt2XF5fgJVpUTxggfGgh-u3ecnw4-iMJYaJL4PUWZ0fQ30PVivkfxCsaGeXFURFY1n9rGUovvmn4gjhnLYdWzv1jAMrtWxpTPOZmjilw2he_luP-qSjZukWgwL7LDF2AE08YfAU1ZfHF9nGi1cx52MZS_6zv-5JbE27ctJ5w4kkP_keKx-Cw5tdC2TvE"
            />
          ) : (
            <iframe
              title="Landing Page"
              src="https://f.inno.keolis.com/f/l/?q=BSLqpzmY16RtCSEShgohLTb9NHftVXSchI5U5X7tFck1wSvnK6Zju4LY9embQyGwFPQdea4JaeTvJx99yXHXclaUhOvyWW_WeYDVvlSeXvuqssfSD2RlonLzJpgW8R20QGbQNQqp7rusHzAE9gDZIjcD53XmVjJPoxHfCcN2-4__pURFfpdMI14KVPoBL9VUVewRCg07AwrLLZ33NS3YaE_sOSd8bVgxSs-DXSo3dHT9AsYS-1K3UrI9nal2LqNc"
            />
          )}
        </div>
      </section>
      </Layout>
    )
}

export const Head: React.FC<ThematicFolderPageProps> = ({ data, pageContext }) => {
  const isBrowser = typeof window !== "undefined"
  const defaultDomain = "https://innovation.keolis.com"
  return (
    isBrowser && (
      <>
        <SEO
          title={data.datoCmsThematicFoldersPage.title}
          description={data.datoCmsThematicFoldersPage.metaDescription}
          locale={pageContext.locale}
          noindex={data.datoCmsThematicFoldersPage.noindex}
        />
        {typeof window !== "undefined" && (
          <HrefLangLinks
            defaultDomain={window.location.origin}
            defaultLocale={pageContext.defaultLocale}
            slugs={[pageContext.slugs._allThematicFoldersPageSlugLocales]}
          />
        )}
      </>
    )
  )
}

export const pageQuery = graphql`
    query ThematicFolderPage($locale: String!) {
        datoCmsGlobalConfiguration {
            locales
        }
        datoCmsSlugsConfiguration(locale: $locale) {
            thematicFoldersPageSlug
            projectsNewsInsightsPageSlug
        }
        datoCmsFooter(locale: $locale) {
            ...FooterFields
        }
        datoCmsHeader(locale: $locale) {
            ...HeaderFields
        }
        datoCmsThematicFoldersPage(locale: $locale) {
            title
            metaDescription
            noindex
            buttonSeeMoreLabel
            ...BannerThematicFoldersFields
            ...ThematicFolderCoverFields
            ...ThematicFoldersFields
        }
        datoCmsHomePage(locale: $locale) {
            ...NewsletterFields
        }
    }
`

export default ThematicFolderPage
